import * as R from 'ramda'

const getTitle = ({
    content,
    locale,
    defaultLocale,
    initialLocale,
}) => {
    const localeOrPath = (o) => (l) => R.or(l, R.path([o], content))
    // alter & return `Other (please specify)`
    const alterOtherValue = (v) => ((typeof v === 'string') ? R.split('[Q |', v)[0] : v)
    const a = R.pipe(
        R.path([locale]),
        localeOrPath(defaultLocale),
        localeOrPath(initialLocale),
        alterOtherValue,
    )(content)

    return a
}

const getQuestionTitle = ({
    content,
    formContent,
    locale,
    defaultLocale,
    initialLocale,
}) => {
    const formTitle = getTitle({
        content: formContent,
        locale,
        defaultLocale,
        initialLocale,
    })

    const title = getTitle({
        content,
        locale,
        defaultLocale,
        initialLocale,
    })

    return formTitle
        ? `${formTitle} - ${title}`
        : title
}

const getOptionMetric = ({
    availableMetrics,
    metricId,
    locale,
    defaultLocale,
    initialLocale,
}) => {
    const content = availableMetrics.get(metricId)

    return getTitle({
        content,
        locale,
        defaultLocale,
        initialLocale,
    })
}

const getOptionTitle = ({
    langs,
    locale,
    defaultLocale,
    initialLocale,
}) => (
    getTitle({
        content: langs,
        locale,
        defaultLocale,
        initialLocale,
    })
)

const isSingleAxis = ({ questionTypeCode }) => (
    ['CO', 'SB', 'CH', 'PC', 'OD', 'RD', 'UV', 'TL'].includes(questionTypeCode)
)

const isDoubleAxis = ({ questionTypeCode }) => (
    ['TB', 'RT'].includes(questionTypeCode)
)

const getParentOptions = (parentId, survey) => {
    if (!parentId) return []

    const [parentQuestion] = survey.pages.map((p) => R.pathOr([], ['questions'], p).find(({ id }) => id.toUpperCase() === parentId.toUpperCase())).filter((val) => !R.isNil(val))

    if (!parentQuestion) return []

    return getParentOptions(parentQuestion.parentId, survey)
        .concat(R.pathOr([], ['question', 'optionSet', 'options'], parentQuestion).filter(({ isNonReporting }) => !isNonReporting))
}

const getParentFromQlist = (parentId, questionLibraryLists) => {
    if (questionLibraryLists.size < 1) return null
    const allQListQuestions = Array.from(questionLibraryLists.values()).flat()
    const parentQuestion = allQListQuestions.find((q) => q.questionId.toLowerCase() === parentId)
    return parentQuestion
}

const getAiQuestions = async (appStore) => {
    if (!process.env.AI_QUESTION) return
    try {
        if (!appStore || !appStore.survey) throw Error('Store or survey not provided')
        const { survey } = appStore
        const res = await appStore.http.get(`/survey/${survey.id}/aiquestions`)
        const data = Array.isArray(res) ? res : []
        // in the code, this definition was adopted:
        // targetQuestionsIds: open-ended questions, where button will appear (children)
        // questionIds: multiple-choice questions, fed from open-ended (parent)
        // parent to children relationshipt -> 1:n
        appStore.surveyAiQuestionMapping = new Map(data.map(
            (item) => [item.questionId.toLowerCase(), item.targetQuestionId.toLowerCase()],
        ))
    } catch (e) {
        console.error(e)
    }
}

const getQuestionById = async (qid, store) => {
    try {
        const res = await store.http.get(`/api/question/${qid}/7`)
        return res.question
    } catch (error) {
        store.addNotification(null, 'Could not fetch question', 'error')
        console.error(error)
    }
}

export {
    getTitle,
    getQuestionTitle,
    getOptionMetric,
    getOptionTitle,
    isSingleAxis,
    isDoubleAxis,
    getParentOptions,
    getParentFromQlist,
    getAiQuestions,
    getQuestionById,
}
